import { GetItemCounts, useInfiniteReferralsSignUps } from '@ukpostbox/client-data';
import {
	ContentBlock,
	ContentLoader,
	FlexAlign,
	FlexJustify,
	InfiniteLoadTrigger,
	ItemRow,
	ItemRowHeader,
	RichEmptyState,
	StackHorizontal,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDate } from '@ukpostbox/helpers';
import React, { useEffect, useRef, useState } from 'react';
import { ClipboardImage } from '../../../_Global/Images/ClipboardImage';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';

function SignUps() {
	const { t } = useTranslation();
	const { currentLocale, updatePageMeta } = useSite();

	const {
		data,
		status,
		error,
		dataUpdatedAt,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
		isStale,
		isRefetching,
	} = useInfiniteReferralsSignUps();

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	const referralsSentRef = useRef<any>(null);

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [dataUpdatedAt, data]);

	useEffect(() => {
		updatePageMeta({
			title: t(`settings.sections.${'Sign-Ups'}`),
		});
	}, [currentLocale]);

	return (
		<>
			<StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass='mb-xs'>
				<h2 className='mb-0'>{t(`settings.sections.${'Sign-Ups'}`)}</h2>
			</StackHorizontal>

			<div className='card commissions-signups-rows' ref={referralsSentRef}>
				<ItemRowHeader title='Signups' sticky>
					<div>{t('settings.referralSignUps.headings.signUpDate')}</div>
					<div>{t('settings.referralSignUps.headings.commissionSplit')}</div>
					<div>{t('settings.referralSignUps.headings.commissionEarned')}</div>
					<div>{t('settings.referralSignUps.headings.commissionUnpaid')}</div>
					<div>{t('settings.referralSignUps.headings.commissionPaid')}</div>
				</ItemRowHeader>

				{status === 'pending' ? (
					<ContentLoader childHeight='5em' childCount={10} />
				) : status === 'error' ? (
					<ContentBlock error stacked title={error?.name} content={error?.message} />
				) : (
					<>
						{data.pages.map((group) => {
							if (group.totalRecords === 0) {
								return (
									<RichEmptyState
										title={t('settings.referralSignUps.noData.title')}
										description={t('settings.referralSignUps.noData.description')}
										media={<ClipboardImage />}
									/>
								);
							}

							return (
								<>
									{group.data.map((commissionEntry) => (
										<ItemRow
											title={`Signups Entry ${commissionEntry.signUpDate}`}
											key={`commissionEntry${commissionEntry.signUpDate}`}
											static
										>
											<div>{FormatLocaleDate(commissionEntry.signUpDate, currentLocale)}</div>
											<div>{commissionEntry.commissionSplit}</div>
											<div>{commissionEntry.commissionEarned}</div>
											<div>{commissionEntry.commissionUnpaid}</div>
											<div>{commissionEntry.commissionPaid}</div>
										</ItemRow>
									))}
								</>
							);
						})}

						{itemCounts.total > 0 && (
							<InfiniteLoadTrigger
								loaded={itemCounts.loaded}
								totalCount={itemCounts.total}
								hasNextPage={hasNextPage}
								fetchNextPage={fetchNextPage}
								isStale={isStale}
								isRefetching={isRefetching}
								isFetchingNextPage={isFetchingNextPage}
							/>
						)}
					</>
				)}
			</div>
		</>
	);
}

export { SignUps };
